// extracted by mini-css-extract-plugin
module.exports = {"seo_box":"seoBox__seo_box___2BZJD","seo_box__header_wrapper":"seoBox__seo_box__header_wrapper___368XX","seo_box__title":"seoBox__seo_box__title___aphGz","seo_box__expanded":"seoBox__seo_box__expanded___3yzvY"};
    if(module.hot) {
      // 1665497109305
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  